import React from 'react';
import { Sparkles, Shield, TrendingUp } from 'lucide-react';

const NewChapterSection = () => {
  return (
    <section
      id="new-chapter"
      className="py-20 md:py-32 bg-[#1e3a5f]"
      data-testid="new-chapter-section"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          {/* Content */}
          <div className="order-2 lg:order-1">
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-[#c9a227]/20 rounded-full text-[#c9a227] text-sm font-medium mb-6">
              <Sparkles className="w-4 h-4" />
              A New Beginning
            </div>
            
            <h2
              className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-6 leading-tight"
             
            >
              A New Chapter with{' '}
              <span className="text-[#c9a227]">RSJB Nursing Homes</span>
            </h2>

            <p className="text-white/90 text-lg mb-6 leading-relaxed">
              Abney Low Nursing Home is now newly operated by RSJB Nursing Homes.
            </p>

            <p className="text-white/80 mb-8 leading-relaxed">
              This transition marks a renewed focus on quality, safety and resident wellbeing. With strengthened leadership, improved systems and a commitment to continuous improvement, we are dedicated to delivering the highest standards of care.
            </p>

            <p className="text-white/80 mb-10 leading-relaxed">
              Our priority is simple: to ensure every resident feels safe, supported and truly at home, while giving families confidence and peace of mind.
            </p>

            {/* Key Points */}
            <div className="space-y-4">
              <div className="flex items-center gap-4 p-4 bg-white/5 rounded-xl backdrop-blur-sm">
                <div className="w-10 h-10 rounded-lg bg-[#c9a227] flex items-center justify-center flex-shrink-0">
                  <Shield className="w-5 h-5 text-[#1e3a5f]" />
                </div>
                <div>
                  <h4 className="font-semibold text-white">Strengthened Leadership</h4>
                  <p className="text-sm text-white/70">Experienced management team driving quality improvements</p>
                </div>
              </div>
              <div className="flex items-center gap-4 p-4 bg-white/5 rounded-xl backdrop-blur-sm">
                <div className="w-10 h-10 rounded-lg bg-[#c9a227] flex items-center justify-center flex-shrink-0">
                  <TrendingUp className="w-5 h-5 text-[#1e3a5f]" />
                </div>
                <div>
                  <h4 className="font-semibold text-white">Continuous Improvement</h4>
                  <p className="text-sm text-white/70">Dedicated to exceeding care standards every day</p>
                </div>
              </div>
            </div>
          </div>

          {/* Image */}
          <div className="order-1 lg:order-2 relative">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <img
                src="https://customer-assets.emergentagent.com/job_github-sync-86/artifacts/d0p83hpc_15188_2204240158016.webp"
                alt="The beautiful garden and patio area at Abney Low Nursing Home"
                className="w-full h-[400px] lg:h-[500px] object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#1e3a5f]/50 to-transparent" />
            </div>
            {/* Decorative element */}
            <div className="absolute -z-10 -top-4 -right-4 w-full h-full border-2 border-[#c9a227]/30 rounded-2xl" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default NewChapterSection;
